<template>
  <div class="app-container">
    <div class="filter-container">
      <el-input
        v-model="listQuery.name"
        placeholder="租户名称"
        style="width: 200px;"
        class="filter-item"
        @keyup.enter.native="handleFilter"
      />
      <el-select v-model="listQuery.status" placeholder="状态" clearable style="width: 150px" class="filter-item">
        <el-option label="正常" value="active" />
        <el-option label="禁用" value="inactive" />
        <el-option label="过期" value="expired" />
      </el-select>
      <el-button class="filter-item" type="primary" icon="el-icon-search" @click="handleFilter">搜索</el-button>
      <el-button class="filter-item" style="margin-left: 10px;" type="success" icon="el-icon-plus" @click="handleCreate">新增</el-button>
    </div>

    <el-table
      v-loading="listLoading"
      :data="list"
      border
      fit
      highlight-current-row
      style="width: 100%;"
    >
      <el-table-column label="ID" prop="tenantId" align="center" width="60">
        <template slot-scope="{row}">
          <span>{{ row.tenantId }}</span>
        </template>
      </el-table-column>
      <el-table-column label="租户编号" prop="tenantNo" align="center" width="140">
        <template slot-scope="{row}">
          <span>{{ row.tenantNo }}</span>
        </template>
      </el-table-column>
      <el-table-column label="外部ID" prop="externalId" align="center" width="120">
        <template slot-scope="{row}">
          <span>{{ row.externalId || '-' }}</span>
        </template>
      </el-table-column>
      <el-table-column label="租户名称" prop="name" align="center" width="200">
        <template slot-scope="{row}">
          <span>{{ row.name }}</span>
        </template>
      </el-table-column>
      <el-table-column label="地区" align="center" width="220">
        <template slot-scope="{row}">
          <span>{{ row.provinceName }}{{ row.cityName }}{{ row.districtName || '' }}</span>
        </template>
      </el-table-column>
      <el-table-column label="联系人" prop="contactPerson" align="center" width="100">
        <template slot-scope="{row}">
          <span>{{ row.contactPerson }}</span>
        </template>
      </el-table-column>
      <el-table-column label="联系电话" prop="contactPhone" align="center" width="120">
        <template slot-scope="{row}">
          <span>{{ row.contactPhone }}</span>
        </template>
      </el-table-column>
      <el-table-column label="状态" prop="status" align="center" width="80">
        <template slot-scope="{row}">
          <el-tag :type="row.status | statusFilter">
            {{ row.status === 'active' ? '正常' : row.status === 'inactive' ? '禁用' : '过期' }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column label="创建时间" prop="createdAt" align="center" width="160">
        <template slot-scope="{row}">
          <span>{{ row.createdAt | parseTime }}</span>
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center" class-name="small-padding fixed-width">
        <template slot-scope="{row}">
          <el-button type="primary" size="mini" @click="handleUpdate(row)">编辑</el-button>
          <el-button
            :type="row.status === 'active' ? 'warning' : 'success'"
            size="mini"
            @click="handleStatusChange(row)"
          >
            {{ row.status === 'active' ? '禁用' : '启用' }}
          </el-button>
          <el-button type="danger" size="mini" @click="handleDelete(row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <pagination
      v-show="total>0"
      :total="total"
      :page.sync="listQuery.pageNum"
      :limit.sync="listQuery.pageSize"
      @pagination="getList"
    />

    <el-dialog :title="textMap[dialogStatus]" :visible.sync="dialogFormVisible" width="600px">
      <el-form ref="dataForm" :rules="dialogStatus === 'update' ? updateRules : rules" :model="temp" label-position="left" label-width="100px" style="width: 450px; margin-left:30px;">
        <el-form-item v-if="dialogStatus === 'update'" label="租户编号">
          <el-input v-model="temp.tenantNo" disabled />
        </el-form-item>
        <el-form-item v-if="dialogStatus === 'update' && temp.externalId" label="外部ID">
          <el-input v-model="temp.externalId" disabled />
        </el-form-item>
        <el-form-item label="租户名称" prop="name">
          <el-input v-model="temp.name" />
        </el-form-item>
        <el-form-item label="省/市/区" prop="regionCodes">
          <!-- 编辑模式：显示文本 -->
          <template v-if="dialogStatus === 'update'">
            <el-input :value="temp.provinceName + (temp.cityName ? ' / ' + temp.cityName : '') + (temp.districtName ? ' / ' + temp.districtName : '')" disabled />
          </template>
          <!-- 新增模式：使用级联选择器 -->
          <template v-else>
            <el-cascader
              v-model="temp.regionCodes"
              :options="regionData"
              :props="{ value: 'value', label: 'label', children: 'children', checkStrictly: true }"
              placeholder="请选择省市区（可选择省或省市）"
              style="width: 100%"
              @change="handleRegionChange"
            />
            <div style="color: #E6A23C; font-size: 12px; margin-top: 5px;">
              <i class="el-icon-warning"></i> 注意：省市区一旦设定将无法修改，请谨慎选择！
            </div>
          </template>
        </el-form-item>
        <el-form-item label="联系人" prop="contactPerson">
          <el-input v-model="temp.contactPerson" />
        </el-form-item>
        <el-form-item label="联系电话" prop="contactPhone">
          <el-input v-model="temp.contactPhone" />
        </el-form-item>
        <el-form-item label="联系邮箱" prop="contactEmail">
          <el-input v-model="temp.contactEmail" />
        </el-form-item>
        <el-form-item label="域名" prop="domain">
          <el-input v-model="temp.domain" />
        </el-form-item>
        <el-form-item label="过期时间" prop="expireAt">
          <el-date-picker v-model="temp.expireAt" type="datetime" placeholder="选择日期时间" style="width: 100%" />
        </el-form-item>
        <el-divider content-position="left">API配置</el-divider>
        <el-form-item label="订单API地址" prop="config.orderApiUrl">
          <el-input v-model="temp.config.orderApiUrl" placeholder="请输入订单请求地址" />
        </el-form-item>
        <el-form-item label="商品API地址" prop="config.productApiUrl">
          <el-input v-model="temp.config.productApiUrl" placeholder="请输入商品请求地址" />
        </el-form-item>
        <el-form-item label="App Key" prop="config.appKey">
          <el-input v-model="temp.config.appKey" placeholder="请输入请求Key" />
        </el-form-item>
        <el-form-item label="App Secret" prop="config.appSecret">
          <el-input v-model="temp.config.appSecret" placeholder="请输入请求密钥"/>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取消</el-button>
        <el-button type="primary" @click="dialogStatus==='create'?createData():updateData()">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { listTenants, createTenant, updateTenant, deleteTenant, updateTenantStatus } from '@/api/tenant'
import Pagination from '@/components/Pagination'
import { regionData, getRegionNamesByCodes } from '@/data/region'

export default {
  name: 'TenantList',
  components: { Pagination },
  filters: {
    statusFilter(status) {
      const statusMap = {
        active: 'success',
        inactive: 'info',
        expired: 'danger'
      }
      return statusMap[status]
    },
    parseTime(time) {
      if (!time) return ''
      const date = new Date(time)
      return date.toLocaleString()
    }
  },
  data() {
    return {
      list: null,
      total: 0,
      listLoading: true,
      regionData: regionData,
      listQuery: {
        pageNum: 1,
        pageSize: 20,
        name: undefined,
        status: undefined
      },
      temp: {
        tenantId: undefined,
        tenantNo: '',
        externalId: '',
        name: '',
        domain: '',
        provinceCode: '',
        provinceName: '',
        cityCode: '',
        cityName: '',
        districtCode: '',
        districtName: '',
        regionCodes: [],
        contactPerson: '',
        contactPhone: '',
        contactEmail: '',
        expireAt: undefined,
        config: {
          orderApiUrl: '',
          productApiUrl: '',
          appKey: '',
          appSecret: ''
        }
      },
      dialogFormVisible: false,
      dialogStatus: '',
      textMap: {
        update: '编辑',
        create: '创建'
      },
      rules: {
        name: [{ required: true, message: '请输入租户名称', trigger: 'blur' }],
        regionCodes: [{ type: 'array', required: true, message: '请选择省市区', trigger: 'change' }],
        contactPerson: [{ required: true, message: '请输入联系人', trigger: 'blur' }],
        contactPhone: [{ required: true, message: '请输入联系电话', trigger: 'blur' }]
      },
      // 编辑模式的验证规则（不需要验证省市区）
      updateRules: {
        name: [{ required: true, message: '请输入租户名称', trigger: 'blur' }],
        contactPerson: [{ required: true, message: '请输入联系人', trigger: 'blur' }],
        contactPhone: [{ required: true, message: '请输入联系电话', trigger: 'blur' }]
      }
    }
  },
  created() {
    this.getList()
  },
  methods: {
    getList() {
      this.listLoading = true
      listTenants(this.listQuery).then(response => {
        this.list = response.data.records
        this.total = response.data.total
        this.listLoading = false
      })
    },
    handleFilter() {
      this.listQuery.pageNum = 1
      this.getList()
    },
    resetTemp() {
      this.temp = {
        tenantId: undefined,
        tenantNo: '',
        externalId: '',
        name: '',
        domain: '',
        provinceCode: '',
        provinceName: '',
        cityCode: '',
        cityName: '',
        districtCode: '',
        districtName: '',
        regionCodes: [],
        contactPerson: '',
        contactPhone: '',
        contactEmail: '',
        expireAt: undefined,
        config: {
          orderApiUrl: '',
          productApiUrl: '',
          appKey: '',
          appSecret: ''
        }
      }
    },
    handleRegionChange(value) {
      if (value && value.length >= 1) {
        // 根据选择的级别获取名称
        const names = getRegionNamesByCodes(value[0], value[1], value[2])
        
        // 省
        this.temp.provinceCode = value[0]
        this.temp.provinceName = names.provinceName
        
        // 市（可选）
        if (value.length >= 2) {
          this.temp.cityCode = value[1]
          this.temp.cityName = names.cityName
        } else {
          this.temp.cityCode = ''
          this.temp.cityName = ''
        }
        
        // 区（可选）
        if (value.length >= 3) {
          this.temp.districtCode = value[2]
          this.temp.districtName = names.districtName
        } else {
          this.temp.districtCode = ''
          this.temp.districtName = ''
        }
        
        // 清除该字段的验证错误
        this.$nextTick(() => {
          this.$refs['dataForm'].validateField('regionCodes')
        })
      }
    },
    handleCreate() {
      this.resetTemp()
      this.dialogStatus = 'create'
      this.dialogFormVisible = true
      this.$nextTick(() => {
        this.$refs['dataForm'].clearValidate()
      })
    },
    createData() {
      this.$refs['dataForm'].validate((valid) => {
        if (valid) {
          const tempData = Object.assign({}, this.temp)
          delete tempData.tenantId
          delete tempData.regionCodes
          createTenant(tempData).then((response) => {
            this.dialogFormVisible = false
            this.$notify({
              title: '成功',
              message: '创建成功，租户编号：' + (response.data.tenantNo || ''),
              type: 'success',
              duration: 3000
            })
            this.getList()
          })
        }
      })
    },
    handleUpdate(row) {
      this.temp = Object.assign({}, row)
      if (!this.temp.config) {
        this.temp.config = {}
      }
      this.temp.config = Object.assign({
        orderApiUrl: '',
        productApiUrl: '',
        appKey: '',
        appSecret: ''
      }, this.temp.config)
      // 编辑模式不需要 regionCodes，直接显示文本
      this.temp.regionCodes = []
      this.dialogStatus = 'update'
      this.dialogFormVisible = true
      this.$nextTick(() => {
        this.$refs['dataForm'].clearValidate()
      })
    },
    updateData() {
      this.$refs['dataForm'].validate((valid) => {
        if (valid) {
          const tempData = Object.assign({}, this.temp)
          delete tempData.tenantId
          delete tempData.tenantNo
          delete tempData.status
          delete tempData.createdAt
          delete tempData.updatedAt
          delete tempData.regionCodes

          updateTenant(this.temp.tenantId, tempData).then(() => {
            const index = this.list.findIndex(v => v.tenantId === this.temp.tenantId)
            this.list.splice(index, 1, this.temp)
            this.dialogFormVisible = false
            this.$notify({
              title: '成功',
              message: '更新成功',
              type: 'success',
              duration: 2000
            })
          })
        }
      })
    },
    handleDelete(row) {
      this.$confirm('确定删除该租户吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        deleteTenant(row.tenantId).then(() => {
          this.$notify({
            title: '成功',
            message: '删除成功',
            type: 'success',
            duration: 2000
          })
          this.getList()
        })
      })
    },
    handleStatusChange(row) {
      const newStatus = row.status === 'active' ? 'inactive' : 'active'
      const statusText = newStatus === 'active' ? '启用' : '禁用'

      this.$confirm(`确定${statusText}该租户吗?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        updateTenantStatus(row.tenantId, newStatus).then(() => {
          this.$notify({
            title: '成功',
            message: `${statusText}成功`,
            type: 'success',
            duration: 2000
          })
          this.getList()
        })
      })
    }
  }
}
</script>

<style scoped>
.filter-container {
  margin-bottom: 20px;
}
.filter-item {
  margin-right: 10px;
}
</style>
